export default __webpack_public_path__ + "ce9202ce2eda504c2eb2822d4c051bbd.png";